import type { InjectionKey } from "vue";
import { inject } from "vue";
import type { I18nRuntime } from "./i18n-runtime.ts";

export const I18nRuntimeKey: InjectionKey<I18nRuntime> = Symbol("I18nRuntime");

export function useI18nRuntime(): I18nRuntime {
  const runtime = inject(I18nRuntimeKey);
  if (!runtime) {
    throw new Error(
      "I18nRuntime is not provided. Did you forget app.provide(I18nRuntimeKey, runtime)?",
    );
  }
  return runtime;
}
